<template>
  <div>
    <v-head :title="title"></v-head>
    <div class="signup" style="position: absolute;height: 100%;background: #f3f3f3;" v-wechat-title="$route.meta.title">
      <div class="bannerSignup">
        <img :src="url" alt class>
        <img v-if="!url" src="../../assets/images/bmBg.jpg" />
      </div>
      <div class="inputBox">
        <h2>会议报名查询</h2>
        <div class="inputCont" style="padding-top:35px">
          <div class="inputkuang">

            <dl>
              <dt>报名人手机<sup>*</sup></dt>
              <dd>
                <input maxlength="11" v-model="params.mobile" placeholder="请输入报名人手机" />
              </dd>
            </dl>
            <dl>
              <dt>验证码<sup>*</sup></dt>
              <dd>
                <van-field class="input-item" @input="checkCode()" v-model="code" placeholder="请输入验证码"
                  style="width:100%">
                  <van-button :disabled="disabledCode" v-if="!codeStatus" slot="button" plain size="small"
                    @click="getCode" style="border: 0;">
                    <template v-if="!isSpend">
                      <div class="button-3 text-70">获取验证码</div>
                    </template>
                    <template v-else>
                      <div class="button-6 text-71">重新发送( {{ time }} )</div>
                    </template>
                  </van-button>
                  <van-button v-if="codeStatus" slot="button" plain size="small" style="border: 0;">
                    <template>
                      <div class="button-3 text-70">验证通过</div>
                    </template>
                  </van-button>
                </van-field>
              </dd>
            </dl>
            <div class="buttonDiv">
              <van-button type="primary" block class="but1" @click="search()">提交查询</van-button>
              <van-button type="primary" block @click="goSearch">我要报名</van-button>
            </div>
          </div>
        </div>
        <p class="fontSizeDiv">
          技术支持：智联软件
        </p>
      </div>
    </div>
  </div>

</template>
<script>
  import { getRegisterMeetingDetail, getPZUrl, getMeetingDetail, getUser } from "@/api/dictionary";
  import { Icon, Row, Col, Button, Swipe, SwipeItem, Dialog, Divider, Field, Toast } from "vant";
  import { getSessionStore, setSessionStore } from "../../utils/sessionStorage.js";
  import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
  import { getMobileLoginCode, checkRegisterCode } from "@/api/login";
  import vHead from "@/components/Subhead.vue";
  import Sidentify from "../../components/VerificationCode"; //**引入验证码组件**
  import CryptoJS from 'crypto-js';
  export default {
    data() {
      return {
        type: "1",
        show: null,
        code: null,
        tipContent: "",
        url: "",
        meetingDetail: {},
        title: '查询',
        params: {
          name: null,
          mobile: null,
          meetingId: null
        },
        time: '',
        codeStatus: '',
        isSpend: '',
        disabledCode: false,
        identifyCode: "",
        identifyCodes: "1234567890abcdefjhijklinopqrsduvwxyz",
      };
    },
    components: {
      vHead,
      [Icon.name]: Icon,
      [Row.name]: Row,
      [Col.name]: Col,
      [Button.name]: Button,
      [SwipeItem.name]: SwipeItem,
      [Swipe.name]: Swipe,
      [Dialog.name]: Dialog,
      [Divider.name]: Divider,
      [Field.name]: Field,
      [Toast.name]: Toast,
      "v-sidentify": Sidentify,
    },
    computed: {
      meetingId() {
        return this.$route.query && this.$route.query.meetingId;
      },

    },
    methods: {
      ...mapActions(["securityCheck"]),
      ...mapMutations(["setMemberInfo", "setTitleList", "setAddrList"]),
      goSearch() {
        this.$router.push({ name: 'signup', query: { meetingId: this.meetingId } });
      },
      getPZUrl() {
        let params = {
          id: this.meetingDetail.photoId
        };
        getPZUrl(params).then(res => {
          this.url = res.result;
        });
      },
      search() {

        if (!this.params.mobile) {
          Toast("手机号码不能为空");
          return;
        }
        if (!this.code) {
          Toast("验证码不能为空");
          return;
        }

        this.submit()
      },
      // 验证码
      getCode() {
        this.disabledCode = true
        let mobile = this.params.mobile
        // !this.userParams.code ||
        if (
          !this.params.mobile

        ) {
          this.disabledCode = false
          Toast.fail("请输入手机号！")
          return
        }
        if (this.isSpend) {
          return
        }
        if (!this.$regexp.mobile(mobile)) {
          this.disabledCode = false
          Toast.fail("请输入正确的手机号！")
          return false
        }

        //生成签名
        let timestamp = new Date().getTime();
        let data = "appSecretKey=q7uy43h2t9og1a5c7iuy2p5xa31s1g1x5s9xc2x6p0p1p9p2u9v&mobile=" + mobile + "&timestamp=" + timestamp;
        let sign = this.$md5(data);
        getMobileLoginCode({
          mobile: mobile, captchaUuid: sessionStorage.getItem("captchaUuid"),
          sign: sign, timestamp: timestamp
        }).then((res) => {
          if (res.success) {
            this.isSpend = true
            this.time = 30
            this.count()
          } else {
            Toast.fail(res.message)
            this.isSpend = false
            this.disabledCode = false
          }
        }).catch(error => {
          this.disabledCode = false
        })
      },
      count() {
        --this.time
        if (this.time > 0) {
          setTimeout(() => {
            this.count()
          }, 1000)
        } else {
          this.disabledCode = false
          this.isSpend = false
        }
      },
      checkCode() {
        if (
          this.code &&
          this.code.length == 4
        ) {
          let userParams = {}
          if (sessionStorage.getItem("openid")) {
            userParams.openid = sessionStorage.getItem("openid")
          }
          userParams.userType = 1
          const SECRET_KEY = CryptoJS.enc.Utf8.parse("5684825541395751");
          const SECRET_IV = CryptoJS.enc.Utf8.parse("8319849165191473");
          // 手机号
          let srcsMobile = CryptoJS.enc.Utf8.parse(this.params.mobile);
          let encryptedMobile = CryptoJS.AES.encrypt(srcsMobile, SECRET_KEY, {
            iv: SECRET_IV,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.ZeroPadding
          })
          let mobile1 = CryptoJS.enc.Base64.stringify(encryptedMobile.ciphertext);
          userParams.mobile = mobile1
          userParams.messageCode = this.code
          checkRegisterCode(userParams).then((res) => {
            if (res.success) {
              window.localStorage.setItem(
                "userInfo",
                JSON.stringify(res.result.member)
              )
              this.memberId = res.result.member.id
              sessionStorage.setItem("memberId", res.result.member.id)
              this.codeStatus = true
            } else {
              Toast.fail("验证码错误")
            }
          })
        }
      },

      submit() {
        var params = {
          inviterId: sessionStorage.getItem("inviterId"),
          device: 'mobile',
          grant_type: "sms",
          scope: "server",
          client_id: "mms_meeting",
          client_secret: 123456,
          mobile: this.params.mobile,
          code: this.code,
          username: "",
          password: "",
        };
        this.securityCheck(params)
          .then((res) => {
            console.log('params11111', params)
            this.getUserInfo()
              .then((res) => {
                this.$router.push({ name: 'SignUpmeetingCenter', })
              })
              .catch(() => {
                Toast("用户信息获取失败");
              });
          })
          .catch((res) => {
            Toast("查询失败");
          });
      },
      getUserInfo() {
        return new Promise((resolve) => {
          getUser().then((res) => {
            if (res.success) {
              this.setMemberInfo(res.result);
              setSessionStore("memberId", res.result.id);
              resolve();
            } else {
              Toast("用户信息获取失败");
            }
          });
        });
      },

      getMeetingDetail() {
        getMeetingDetail({ meetingId: this.params.meetingId }).then((res) => {
          if (res.success) {
            this.meetingDetail = res.result.meetingDTO;
            this.$route.meta.title = res.result.meetingDTO.name;
            if (res.result.meetingDTO.photoId) {
              this.getPZUrl();
            }
          }
        });
      }
    },
    mounted() {
      if (!this.params.meetingId) {
        this.params.meetingId = this.meetingId;
      }
      this.getMeetingDetail();
    }
  };
</script>
<style scoped lang="less">
  .button-3 {
    background-color: #1989fa;
    border-radius: 28px;
    border: 1px solid #1989fa;
    padding: 10px 20px 10px 20px;
  }

  .text-70 {
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    font-size: 12px;
    font-weight: NaN;
    text-align: center;
    white-space: nowrap;
    line-height: 17px;
  }

  .button-6 {
    background-color: rgba(250, 173, 122, 0.14);
    border-radius: 28px;
    border: 1px solid #1989fa;
    padding: 10px 20px 10px 20px;
  }

  .text-71 {
    overflow-wrap: break-word;
    color: #1989fa;
    font-size: 12px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 17px;
  }

  /deep/.van-field__value {
    width: 100%;
  }
</style>